export enum INTERACTION_MODES {
  ASSIGN = 'ASSIGN',
  CREATION = 'CREATION'
}
